import { mutations, actions } from "./actions";

const state = {
    // list
    newsfeed: [],
    notice: [],
    community: [],
    mill: [],
    like: [],
    page: 1,
    isLast: false,
    isNoneSubscribe: false,

    fixedScroll: {
        newsfeed: 0,
        notice: 0,
        community: 0,
        mill: 0,
        like: 0
    },

    pages: {
        newsfeed: 1,
        notice: 1,
        community: 1,
        mill: 1,
        like: 1
    },

    // share
    share: {
        toggle: false,
        url: null
    },

    loading: {
        newsfeed: false,
        notice: false,
        community: false,
        mill: false,
        like: false,
        article: false
    },

    boardIcon: ["notice", "airplain", "mill"],

    // data
    typeIcon: {
        공지사항: "notice",
        가정통신문: "airplain",
        급식: "mill"
    },

    typeIconV2: {
        공지사항: "notice",
        가정통신문: "airplain",
        "오늘의 급식": "mill"
    },

    typeIconV3: {
        공지사항: "notice",
        가정통신문: "community",
        "오늘의 급식": "mill"
    }
};

const getters = {
    expectUnlike(state) {
        return state.like.filter(({ isKeeped }) => isKeeped === 1);
    }
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};
